<mat-card-content style="width: 100%">
  <form [formGroup]="FormList">
    <div class="container container-input" fxLayout="row" fxLayout.xs="column">
      <mat-form-field fxFlex="65%">
        <input matInput formControlName="frmDescricao" placeholder="Descrição">
      </mat-form-field>
      <mat-form-field fxFlex="15%">
        <input matInput formControlName="frmEmpresa" placeholder="Empresa">
      </mat-form-field>
      <mat-form-field fxFlex="15%">
        <input matInput formControlName="frmDivisao" placeholder="Divisão">
      </mat-form-field>
      <div fxFlex="5%">
        <a class="linkPesquisa" mat-mini-fab (click)="listar()">
          <mat-icon class="iconPesquisa">search</mat-icon>
        </a>
      </div>
    </div>
  </form>
  <div *ngIf="CarregarLista">
    <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
    </mat-form-field>

    <mat-progress-bar *ngIf="loadProtocolos" class="progress-bar" mode="indeterminate"></mat-progress-bar>
    <div class="table-container">
      <table mat-table [dataSource]="dataSource" matSort style="width:100%;">

        <ng-container matColumnDef="numordint">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%"> Diagrama </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.numordint}} </td>
        </ng-container>

        <ng-container matColumnDef="desordint">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 30%"> Descrição </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.desordint}} </td>
        </ng-container>

        <ng-container matColumnDef="codtipord">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 13%"> Tp.Ordem </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.codtipord}} </td>
        </ng-container>

        <ng-container matColumnDef="codcenlgt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 13%"> Centro Logistico </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.codcenlgt}} </td>
        </ng-container>

        <ng-container matColumnDef="codemp">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 8%"> Empresa </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.codemp}} </td>
        </ng-container>

        <ng-container matColumnDef="coddiv">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 9%"> Divisão </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.coddiv}} </td>
        </ng-container>

        <ng-container matColumnDef="codcenlcr">
          <th mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%"> Centro de Lucro </th>
          <td mat-cell *matCellDef="let element" (click)="NavigateProtocolo(element.numordint)"> {{element.codcenlcr}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>   
  </div>
  <mat-paginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
</mat-card-content>